import { render, staticRenderFns } from "./SImageCarousel.vue?vue&type=template&id=0c1d285e&"
import script from "./SImageCarousel.vue?vue&type=script&lang=ts&"
export * from "./SImageCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./SImageCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports